import type { CreateAgentRequestDTO } from '@conversed/shared/src/central/dto/agent.dto';
import { useCallback } from 'react';

import {
  createAgentsEndpoint,
  deleteAgentsEndpoint,
  getAgentsEndpoint,
  updateAgentsEndpoint,
} from '../../../api/agentsApi';
import { Actions } from '../../../constants/actionTypes';
import { toastErrorTranslated } from '../../../helpers/toast';
import { useMainDispatch } from '../../useMainDispatch';

export const useAgentActions = () => {
  const dispatch = useMainDispatch();

  const fetchAgents = useCallback(async () => {
    try {
      const { data: agents } = await getAgentsEndpoint();
      dispatch({ type: Actions.SET_SETTINGS, payload: { agents } });
    } catch (error) {
      console.error(error);
      toastErrorTranslated(error);
    }
  }, [dispatch]);

  const createAgent = useCallback(
    async (agent: CreateAgentRequestDTO) => {
      try {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: true } });
        await createAgentsEndpoint(agent);
        // TODO do not refetch
        await fetchAgents();
      } catch (error) {
        console.error(error);
        toastErrorTranslated(error);
      } finally {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: false } });
      }
    },
    [dispatch, fetchAgents],
  );

  const editAgent = useCallback(
    async (agentId: string, agentData: CreateAgentRequestDTO) => {
      try {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: true } });
        await updateAgentsEndpoint(agentId, agentData);
        // TODO do not refetch
        await fetchAgents();
      } catch (error) {
        console.error(error);
        toastErrorTranslated(error);
      } finally {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: false } });
      }
    },
    [dispatch, fetchAgents],
  );

  const deleteAgent = useCallback(
    async (agentId: string) => {
      try {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: true } });
        await deleteAgentsEndpoint(agentId);
        // TODO do not refetch
        await fetchAgents();
      } catch (error) {
        console.error(error);
        toastErrorTranslated(error);
      } finally {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: false } });
      }
    },
    [dispatch, fetchAgents],
  );

  return {
    createAgent,
    editAgent,
    deleteAgent,
    fetchAgents,
  };
};
